import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: false,
    selector: 'app-location-delete-show-related-articles-dialog',
    templateUrl: './location-delete-show-related-articles-dialog.component.html'
})
export class LocationDeleteShowRelatedArticlesDialogComponent {
    @Input() articles: any[] = [];

    title: string = 'Articles Associated with Location';
    message: string = 'The following items are linked to this location. ' +
        'After the delete process, these items will no longer have a location or sublocation:';

    constructor(private activeModal: NgbActiveModal) { }

    public cancel() {
        this.activeModal.dismiss(false);
    }

    public confirm() {
        this.activeModal.close(true);
    }
}
